






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Identicon from '@polkadot/vue-identicon';
import keyring from '@polkadot/ui-keyring';
import { u8aToString } from '@polkadot/util';

@Component({
  components: {
    Identicon,
  }
})
export default class CardRecentEvent extends Vue {
  @Prop({ default: 48 }) public size!: number;
  @Prop({ default: 'polkadot'}) public theme!: string;
  @Prop({ default: false}) public open!: boolean;
  @Prop() public header!: any;
  @Prop() public content!: any;
  @Prop() public event!: any;

  public toast(message: string): void {
    this.$buefy.toast.open(message);
  }

  private validateAddress(address: string): boolean {
    try {
      const keyringmagic = keyring.encodeAddress(keyring.decodeAddress(address));
      return true;
    } catch (error) {
      return false;
    }
  }
}
